import { z } from "zod";
import { WhatsAppId } from "./whatsapp-id.schemas.js";

export const WhatsAppBsuidSchema = z
  .string()
  .refine((val) => isValidWhatsAppBsuid(val), {
    message: "Invalid WhatsApp business-scoped user ID format",
  })
  .brand("WhatsAppBsuid");

export type WhatsAppBsuid = z.infer<typeof WhatsAppBsuidSchema>;

// Two uppercase letters (Meta's country prefix), a period, then 1-128
// alphanumerics or periods — the inner `.` admits parent ids (`US.ENT.…`).
const WHATSAPP_BSUID_REGEX = /^[A-Z]{2}\.[A-Za-z0-9.]{1,128}$/;

// Disjointness from a wa_id is structural rather than coincidental: every site
// that tells the two apart does so by shape alone, so an overlap would silently
// reclassify identifiers instead of failing.
function isValidWhatsAppBsuid(value: string): boolean {
  return !WhatsAppId.isValid(value) && WHATSAPP_BSUID_REGEX.test(value);
}

// No normalisation: a BSUID is opaque, and stripping `.` would corrupt it.
export const WhatsAppBsuid = {
  isValid(value: string): boolean {
    return isValidWhatsAppBsuid(value);
  },

  tryCreate(value: string): WhatsAppBsuid | undefined {
    if (!isValidWhatsAppBsuid(value)) {
      return undefined;
    }
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- Required for branded type construction
    return value as WhatsAppBsuid;
  },
} as const;
